(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientGroupSearch', PatientGroupSearch);

    PatientGroupSearch.$inject = ['$resource'];

    function PatientGroupSearch($resource) {
        var resourceUrl =  'api/_search/patient-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
